const PrivacyPolicy = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "32px 16px",
      }}
    >
      <div
        style={{
          background: "#ffffff",
          width: "100%",
          maxWidth: "794px",
          minHeight: "1123px",
          padding: "56px 64px",
          boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
          borderRadius: "4px",
          boxSizing: "border-box",
          lineHeight: 1.5,
          fontSize: "14px",
          textAlign: "justify",
        }}
      >
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Privacy Policy</h1>
        <p>
          <b>CUbits, Inc.&nbsp;| cubits.ai</b>
        </p>
        <p>
          <b>Effective Date:</b>&nbsp;June 1, 2026 <b>Last Updated:</b>&nbsp;May
          2026
        </p>
        <p>
          <b>Please read this Privacy Policy carefully.</b>&nbsp;It explains how
          CUbits, Inc.&nbsp;(&ldquo;<b>CUbits</b>,&rdquo; &ldquo;<b>we</b>
          ,&rdquo; &ldquo;<b>us</b>,&rdquo; or &ldquo;<b>our</b>&rdquo;)
          collects, uses, shares, and protects personal information when you use
          the CUbits platform at cubits.ai, including our curated video
          libraries, AI curation features, cuGPT, and creator tools
          (collectively, the &ldquo;<b>Service</b>&rdquo;). By accessing or
          using the Service, you agree to the practices described here. This
          Policy is incorporated into our{" "}
          <a href="/terms-and-conditions/">Terms and Conditions</a>&nbsp;by reference;
          capitalized terms not defined here have the meanings given in the
          Terms.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Who We Are</h1>
        <p>
          The entity responsible for personal information processed through the
          Service is:
        </p>
        <p>
          <b>CUbits, Inc.</b>&nbsp;100 Overlook Center, 2nd Floor Princeton, NJ,
          United States Email: support@cubits.ai Website: www.cubits.ai
        </p>
        <p>
          CUbits was founded by faculty and students from Princeton University
          and operates an AI-powered video learning platform.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Information We Collect</h1>
        <p>We collect the following categories of personal information.</p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Information You Provide Directly</h2>
        <ul>
          <li>
            <b>Account information:</b>&nbsp;name, email address, password
            (stored hashed), and where applicable your institution, role
            (student, educator, creator), and profile details.
          </li>
          <li>
            <b>Subscription and payment information:</b>&nbsp;the plan you
            select, billing country, transaction history, and limited payment
            metadata. Full card and bank details are entered into our payment
            processor (Stripe) and are not stored on CUbits&rsquo; own systems.
          </li>
          <li>
            <b>Source Material and creator content:</b>&nbsp;for educators and
            content creators, the videos, slides, documents, images, and other
            materials you upload to the Service, including any personal
            information they contain about third parties (see &ldquo;Creator
            Content and Third-Party Data&rdquo; below).
          </li>
          <li>
            <b>cuGPT and AI interactions:</b>&nbsp;the questions, prompts, and
            follow-ups you submit to cuGPT, and the responses it returns.
          </li>
          <li>
            <b>Communications:</b>&nbsp;the content of messages you send to
            support, feedback, survey responses, and any reviews or comments you
            post on the Service.
          </li>
        </ul>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Information Collected Automatically</h2>
        <ul>
          <li>
            <b>Learning activity:</b>&nbsp;courses viewed, videos watched, watch
            time, search queries within the platform, quiz responses, completion
            data, and progress signals used to personalize recommendations.
          </li>
          <li>
            <b>Device and technical data:</b>&nbsp;IP address, browser type and
            version, operating system, device identifiers, language, time zone,
            and referring URLs.
          </li>
          <li>
            <b>Usage analytics:</b>&nbsp;pages visited, features used, clicks,
            session duration, and timestamps.
          </li>
          <li>
            <b>Cookies and similar technologies:</b>&nbsp;see &ldquo;Cookies and
            Tracking&rdquo; below.
          </li>
          <li>
            <b>Diagnostic data:</b>&nbsp;error logs and performance metrics.
          </li>
        </ul>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Information From Third Parties</h2>
        <ul>
          <li>
            <b>Single sign-on providers:</b>&nbsp;if you choose to sign in with
            Google, Microsoft, or a similar provider, we receive your name,
            email, and a profile identifier as authorized by you.
          </li>
          <li>
            <b>Payment processor (Stripe):</b>&nbsp;transaction status, fraud
            signals, and limited payment metadata.
          </li>
          <li>
            <b>Institutional partners:</b>&nbsp;where your access is provided
            through a university, school, or employer, we may receive roster
            information necessary to provision your account.
          </li>
        </ul>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Sensitive Information</h2>
        <p>
          We do not require sensitive personal information (such as health,
          biometric, racial or ethnic origin, religious beliefs, or precise
          geolocation). Please do not upload Source Material containing
          sensitive personal information about identifiable individuals unless
          you have a lawful basis to do so and have informed those individuals.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Creator Content and Third-Party Data</h1>
        <p>
          Creators may upload Source Material that contains personal information
          about third parties (for example, names or images appearing in a
          lecture video). In line with the Terms and Conditions:
        </p>
        <ul>
          <li>
            <b>You are responsible</b>&nbsp;for ensuring you have the rights,
            consents, and lawful basis needed to upload such material;
          </li>
          <li>
            <b>You must provide notice</b>&nbsp;to the individuals concerned
            where required by law;
          </li>
          <li>
            <b>CUbits processes that material</b>&nbsp;only to host, deliver,
            secure, and improve the Service, and in accordance with this Policy
            and your creator agreement.
          </li>
        </ul>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>How We Use Personal Information</h1>
        <p>We use personal information for the following purposes:</p>
        <ul>
          <li>
            <b>Providing the Service</b>&nbsp;&mdash; operating your account,
            delivering video content, generating AI summaries, running cuGPT,
            hosting creator content, and enabling enrollment in courses.
          </li>
          <li>
            <b>Personalization</b>&nbsp;&mdash; recommending videos and courses,
            surfacing relevant search results, and adapting the interface to
            your preferences.
          </li>
          <li>
            <b>Payments and subscriptions</b>&nbsp;&mdash; processing
            subscription purchases, renewals, and refunds; calculating creator
            royalties; and complying with tax and accounting obligations.
          </li>
          <li>
            <b>AI features and improvement</b>&nbsp;&mdash; generating cuGPT
            responses, summaries, and Q&amp;A, and improving the underlying
            models and curation technology as described in the next section.
          </li>
          <li>
            <b>Communications</b>&nbsp;&mdash; responding to support requests,
            sending service announcements and transactional emails (receipts,
            password resets), and, where you have opted in or where permitted by
            law, sending educational and marketing updates.
          </li>
          <li>
            <b>Safety, security, and integrity</b>&nbsp;&mdash; detecting fraud,
            abuse, copyright infringement, account sharing, and policy
            violations; enforcing the Terms; and protecting users and third
            parties.
          </li>
          <li>
            <b>Product analytics</b>&nbsp;&mdash; understanding how the Service
            is used, identifying bugs, and improving features; generally
            performed using aggregated or pseudonymized data.
          </li>
          <li>
            <b>Legal compliance</b>&nbsp;&mdash; complying with applicable law,
            responding to lawful requests from authorities, and exercising or
            defending legal claims.
          </li>
        </ul>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>cuGPT and AI Processing</h1>
        <p>
          Because AI is central to the Service, we are explicit about how it
          works.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>How AI Processes Your Data</h2>
        <p>
          When you watch videos, run searches, or interact with cuGPT, the
          Service uses our AI curation technology &mdash; protected by Princeton
          University patents granted in 2021 &mdash; together with third-party
          large language models, to generate summaries, surface relevant
          content, and answer questions. This involves transmitting your
          prompts, related content, and context to AI systems and receiving
          outputs in return.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Use of AI Interactions to Improve Our Models</h2>
        <p>
          As stated in our Terms and Conditions,{" "}
          <b>
            your interactions with cuGPT, including queries and responses, may
            be used to improve the Service and the underlying AI models.
          </b>
          &nbsp;Where we use this data for model improvement, we apply the
          following protections:
        </p>
        <ul>
          <li>
            We strip or aggregate direct identifiers (name, email, account ID)
            where technically feasible before such data is used for model
            improvement;
          </li>
          <li>We do not use payment information for model improvement;</li>
          <li>We do not sell AI interaction data to third parties;</li>
          <li>
            Where required by law, we obtain consent or honor opt-out signals
            before using your interactions in this way.
          </li>
        </ul>
        <p>
          You may <b>request that your cuGPT interaction history be excluded</b>
          &nbsp;from future model-improvement work by contacting
          support@cubits.ai. This request will apply on a forward-looking basis
          from the date we process it.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Third-Party AI Providers</h2>
        <p>
          We use third-party AI model providers to power parts of cuGPT. These
          providers act as service providers to CUbits and are contractually
          restricted from using your content for their own purposes, except as
          permitted by your interactions with the Service. A current list of
          these providers is available on request at support@cubits.ai.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Automated Decision-Making</h2>
        <p>
          CUbits does not make decisions producing legal or similarly
          significant effects about you based solely on automated processing. AI
          outputs (summaries, recommendations, Q&amp;A) are intended as learning
          aids and may contain errors or omissions, as described in the Terms.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Abuse and Safety Review</h2>
        <p>
          Limited automated and, where necessary, human review may occur on
          content flagged for safety, abuse, copyright, or policy reasons. Human
          review is restricted to authorized personnel under confidentiality
          obligations.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>How We Share Personal Information</h1>
        <p>We share personal information only as set out below.</p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>With Other Users</h2>
        <ul>
          <li>
            <b>Educators and creators</b>&nbsp;see information necessary to
            operate the courses and content they offer, such as student names
            (or pseudonyms), enrollment status, and progress.
          </li>
          <li>
            <b>Other students</b>&nbsp;may see your public profile, reviews, and
            any content you choose to post publicly within the Service.
          </li>
        </ul>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>With Service Providers</h2>
        <p>
          We share personal information with vetted service providers who act on
          our behalf, including:
        </p>
        <ul>
          <li>
            <b>Stripe</b>&nbsp;&mdash; payment processing
          </li>
          <li>
            <b>Cloud hosting and storage providers</b>
          </li>
          <li>
            <b>AI model providers</b>&nbsp;&mdash; see &ldquo;cuGPT and AI
            Processing&rdquo;
          </li>
          <li>
            <b>Email and notification providers</b>
          </li>
          <li>
            <b>Analytics and error-monitoring providers</b>
          </li>
          <li>
            <b>Customer support and ticketing tools</b>
          </li>
          <li>
            <b>Fraud prevention and identity verification services</b>
          </li>
        </ul>
        <p>
          Service providers are bound by contract to use personal information
          only for purposes we authorize and to apply appropriate safeguards.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Legal Disclosures</h2>
        <p>
          We may disclose personal information when we believe in good faith it
          is necessary to:
        </p>
        <ul>
          <li>
            Comply with applicable law, court order, subpoena, or other legal
            process;
          </li>
          <li>Enforce our Terms and Conditions and other agreements;</li>
          <li>
            Protect the rights, property, or safety of CUbits, our users, or
            others;
          </li>
          <li>
            Detect, prevent, or address fraud, security, or technical issues.
          </li>
        </ul>
        <p>
          Where lawful and not contrary to law-enforcement instructions, we will
          attempt to notify the affected user before disclosing their data.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>Business Transfers</h2>
        <p>
          If CUbits is involved in a merger, acquisition, financing,
          reorganization, or sale of assets, personal information may be
          transferred as part of that transaction, subject to standard
          confidentiality protections. We will notify affected users where
          required by law.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>No Sale of Personal Information</h2>
        <p>
          <b>
            CUbits does not sell your personal information to third parties.
          </b>
          &nbsp;Where any sharing with analytics or advertising partners might
          qualify as a &ldquo;sale&rdquo; or &ldquo;sharing&rdquo; under
          California or similar laws, you may opt out as described in
          &ldquo;Your Privacy Rights&rdquo; below.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Cookies and Tracking Technologies</h1>
        <p>
          We use cookies and similar technologies (including local storage,
          pixels, and SDKs) for purposes including:
        </p>
        <ul>
          <li>
            <b>Strictly necessary</b>&nbsp;&mdash; authentication, session
            management, and security;
          </li>
          <li>
            <b>Functional</b>&nbsp;&mdash; remembering your preferences and
            settings;
          </li>
          <li>
            <b>Analytics</b>&nbsp;&mdash; understanding how the Service is used
            and improving it;
          </li>
          <li>
            <b>Marketing</b>&nbsp;&mdash; where used and where you have
            consented.
          </li>
        </ul>
        <p>
          Where required by law, we ask for your consent before placing
          non-essential cookies. You can manage cookie preferences through our
          cookie banner, your account settings, or your browser controls.
          Disabling certain cookies may affect functionality.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Data Retention</h1>
        <p>
          We keep personal information only as long as necessary for the
          purposes described in this Policy, including any legal, accounting, or
          reporting requirements. Indicative retention periods:
        </p>
        <table>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Category</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>Retention</p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Account information</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                While your account is active, plus a reasonable period after
                closure for legal and accounting purposes
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Creator Source Material and courses</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                Until you delete them, or a reasonable period after account
                closure
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Subscription and payment records</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                As required by US federal and New Jersey state tax and
                accounting law (typically several years)
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Learning activity and progress</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                While your account is active, plus a limited period after
                closure for analytics
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>cuGPT interactions</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                Retained for service operation and, where applicable, model
                improvement; you may request earlier deletion
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Support communications</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>A reasonable period after the matter is resolved</p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Server logs and diagnostics</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>Typically 30 to 90 days</p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Marketing preferences</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                Until withdrawn, plus a suppression record kept indefinitely
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="1" rowspan="1">
              <p>Backups</p>
            </td>
            <td colspan="1" rowspan="1">
              <p>
                Backups may persist for a limited period after deletion in
                production systems
              </p>
            </td>
          </tr>
        </table>
        <p>
          When retention ends, we delete or irreversibly anonymize the data.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Data Security</h1>
        <p>
          CUbits implements technical and organizational measures designed to
          protect personal information, including:
        </p>
        <ul>
          <li>Encryption in transit (TLS) and at rest for sensitive data;</li>
          <li>Access controls based on least privilege;</li>
          <li>
            Logging and monitoring of access to systems holding personal
            information;
          </li>
          <li>Regular vulnerability scanning and security testing;</li>
          <li>Personnel training and confidentiality obligations;</li>
          <li>Incident response procedures.</li>
        </ul>
        <p>
          No system is perfectly secure. If we become aware of a personal
          information breach that affects you, we will notify you and applicable
          regulators as required by law. Help us protect your account by using a
          strong unique password, enabling multi-factor authentication where
          offered, and keeping your devices secure.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Your Privacy Rights</h1>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>All Users</h2>
        <p>Regardless of where you live, you can:</p>
        <ul>
          <li>
            <b>Access and update</b>&nbsp;much of your account information
            directly in your account settings;
          </li>
          <li>
            <b>Request access, correction, or deletion</b>&nbsp;of your personal
            information by emailing support@cubits.ai;
          </li>
          <li>
            <b>Opt out of marketing emails</b>&nbsp;at any time via the
            unsubscribe link or your notification settings;
          </li>
          <li>
            <b>Request exclusion of your cuGPT interactions</b>&nbsp;from future
            model-improvement work (see &ldquo;cuGPT and AI Processing&rdquo;).
          </li>
        </ul>
        <p>
          We may need to verify your identity before fulfilling certain requests
          and may decline or limit requests as permitted by law (for example,
          where retention is required for legal, accounting, fraud-prevention,
          or safety reasons).
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>US State Privacy Rights</h2>
        <p>
          If you are a resident of{" "}
          <b>California, Colorado, Connecticut, Virginia, Utah, Texas</b>, or
          another US state with a comprehensive consumer privacy law, you may
          have additional rights, including the right to:
        </p>
        <ul>
          <li>
            Know or access the personal information we have collected about you;
          </li>
          <li>Delete personal information we have collected from you;</li>
          <li>Correct inaccurate personal information;</li>
          <li>Obtain a portable copy of your personal information;</li>
          <li>
            Opt out of any &ldquo;sale&rdquo; or &ldquo;sharing&rdquo; of
            personal information, or of targeted advertising and certain
            profiling;
          </li>
          <li>Limit use of sensitive personal information;</li>
          <li>Not be discriminated against for exercising your rights.</li>
        </ul>
        <p>
          To exercise these rights, email support@cubits.ai or use any privacy
          controls provided in the Service. We honor recognized opt-out
          preference signals (such as Global Privacy Control) where required by
          law. California residents may use an authorized agent to submit
          requests, subject to verification and authorization. If we deny your
          request, you may have a right to appeal under your state&rsquo;s law
          &mdash; instructions will be provided in our response.
        </p>
        <h2 style={{ color: "rgb(79, 129, 189)" }}>International Users (GDPR / UK GDPR)</h2>
        <p>
          If you are in the European Economic Area, the United Kingdom, or
          Switzerland, you may have rights under the GDPR or UK GDPR, including
          the rights to access, rectify, erase, restrict, object to, or port
          your personal data, and to withdraw consent where processing is based
          on consent. To exercise these rights, contact support@cubits.ai. You
          also have the right to lodge a complaint with your local supervisory
          authority (in the UK, the Information Commissioner&rsquo;s Office at
          ico.org.uk).
        </p>
        <p>
          Where we rely on legal bases under GDPR, those are typically:
          performance of a contract with you, our legitimate interests (such as
          securing the Service, improving the platform, and communicating with
          users), legal obligation, and consent (for example, for certain
          cookies or marketing).
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>International Data Transfers</h1>
        <p>
          CUbits is based in the United States, and personal information is
          primarily processed in the United States. Our service providers may
          also operate in other countries. Where we transfer personal
          information out of the EEA, the UK, or Switzerland, we apply
          appropriate safeguards (such as the European Commission&rsquo;s
          Standard Contractual Clauses and the UK International Data Transfer
          Addendum) where required. A copy of the safeguards applied is
          available on request at support@cubits.ai.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Adults Only &mdash; No Children&rsquo;s Data</h1>
        <p>
          CUbits is intended for users aged <b>18 and older</b>, as stated in
          our Terms and Conditions. The Service is not directed to children, and
          we do not knowingly collect personal information from anyone under 18.
          If you believe a person under 18 has provided personal information to
          CUbits, please contact support@cubits.ai and we will take steps to
          delete it.
        </p>
        <p>
          Institutions licensing the Service for use by adult learners (such as
          universities or corporate training programs) are responsible for
          ensuring their participants meet this age requirement.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Third-Party Links and Services</h1>
        <p>
          The Service may contain links to third-party websites or integrate
          with third-party services. Their privacy practices are governed by
          their own policies, and CUbits is not responsible for them. Please
          review the privacy notices of any third party before sharing personal
          information with them.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Changes to This Policy</h1>
        <p>
          We may update this Privacy Policy from time to time. When we do, we
          will post the updated version with a new &ldquo;Last Updated&rdquo;
          date and, for material changes, take reasonable steps to notify users
          (for example, by email or in-product notice). Where required by law,
          we will obtain your consent. Your continued use of the Service after
          the effective date constitutes acceptance of the updated Policy.
        </p>
        <h1 style={{ color: "rgb(79, 129, 189)" }}>Contact Us</h1>
        <p>For any privacy-related questions, requests, or complaints:</p>
        <p>
          <b>CUbits, Inc.&nbsp;&mdash; Privacy and Support</b>&nbsp;100 Overlook
          Center, 2nd Floor, Princeton, NJ, United States Email:
          support@cubits.ai Website: www.cubits.ai
        </p>
        <p>
          For creator partnership inquiries, please use the same email address
          and include &ldquo;Creator Partnership&rdquo; in the subject line.
        </p>
        <hr />
        <p></p>
        <p>
          <i>&copy; 2025&ndash;2026 CUbits, Inc.&nbsp;All rights reserved.</i>
        </p>
        <p>
          <i>
            This Privacy Policy is a template and must be reviewed and tailored
            by qualified legal counsel &mdash; particularly to confirm the
            actual data flows, sub-processors, retention periods,
            model-improvement practices, and the jurisdictions of your users
            &mdash; before being relied upon. It does not constitute legal
            advice.
          </i>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
